import React, { useEffect, useState, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import api from "../../../seller-apis/api";
import "../../inventry.css";
import { useAlert } from "react-alert";
import PaginationNew from "../../common/Pagination";
import ProductSKUSearch from "../../common/ProductSearch/ProductSKUSearch";
import BlockedProductCard from "./BlockedProductCard";

import CategoryProductPopup from "../../../Components/addProduct/ChooseProduct/CategoryProductPopup";
// Helper: build minimal payload for getBlockedProductsForSeller
function buildPayload({ pageNo = 1, size = 12, searchIds = null } = {}) {
  const payload = { pageNo, size };
  if (searchIds && searchIds.length > 0) {
    payload.searchIds = searchIds;
  }
  return payload;
}

function BlockedProducts() {
  var outerdiv;
  var loaderDiv;

  const alert = useAlert();

  const [blockedProductsList, setBlockedProductsList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedPage, setSelectedPage] = useState(1);
  const [loaderProduct, setLoaderProduct] = useState("block");
  const [totalRecordId, setTotalRecordId] = useState([]);

  // Tracks active search IDs so pagination stays within search results
  const [activeSearchIds, setActiveSearchIds] = useState(null);

  const [compForPagination] = useState("blockedProducts");
  const [showDetailPopup, setShowDetailPopup]       = useState(false);
  const [currentProductDetail, setCurrentProductDetail] = useState(null);
  useEffect(() => {
    getBlockedProducts();
  }, []);

  // ─── Initial / reset load ──────────────────────────────────────────────────
  const getBlockedProducts = () => {
    setSelectedPage(1);
    setActiveSearchIds(null);

    api.product
      .getBlockedProductsForSeller(buildPayload({ pageNo: 1 }))
      .then((res) => {
        setBlockedProductsList(res.products || []);
        setTotalRecords(res.totalRecords || 0);
        // Store all product IDs for the search component (only needed once)
        if (res.productId && res.productId.length > 0) {
          setTotalRecordId(res.productId);
        } else {
          setTotalRecordId((res.products || []).map((p) => p._id));
        }
        setLoaderProduct("none");
      })
      .catch((err) => {
        setLoaderProduct("none");
        console.log(err);
      });
  };

  // ─── Pagination (respects active search filter) ────────────────────────────
  function paginate(data) {
    applyLoader();
    setSelectedPage(data.number);

    api.product
      .getBlockedProductsForSeller(
        buildPayload({ pageNo: data.number, searchIds: activeSearchIds })
      )
      .then((res) => {
        setBlockedProductsList(res.products || []);
        removeLoader();
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
  }

  // ─── Search handler ────────────────────────────────────────────────────────
  const handleSearch = (value, type, productIds) => {
  // Empty / cleared → reset to full list
  if (!productIds || productIds.length === 0) {
    getBlockedProducts();
    return;
  }

  applyLoader();
  setSelectedPage(1);
  setActiveSearchIds(productIds);

  api.product
    .getBlockedProductsForSeller(
      buildPayload({ pageNo: 1, searchIds: productIds })
    )
    .then((res) => {
      setBlockedProductsList(res.products || []);
      setTotalRecords(res.totalRecords || 0);
      removeLoader();

      if ((res.totalRecords || 0) === 0) {
        alert.info("No blocked products found matching your search.");
      }
    })
    .catch((err) => {
      console.log(err);
      removeLoader();
      alert.error("Search failed. Please try again.");
    });
};

  // ─── Loader helpers ────────────────────────────────────────────────────────
  function applyLoader() {
    outerdiv = document.getElementById("orDeskContain");
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setLoaderProduct("flex");
    outerdiv.classList.add("div-bk");
  }

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setLoaderProduct("none");
    outerdiv.classList.remove("div-bk");
  }

  // ─── Build card props ──────────────────────────────────────────────────────
  const buildCardProps = (item) => {
    let baseImg = "";
    item?.images?.forEach((img) => {
      if (img.baseImage === true) {
        baseImg = img.image.startsWith("products") || img.image.startsWith("mob")
          ? img.image
          : img.image.substr(41);
      }
    });

    const taxClass =
      item?.vendors[0]?.taxClass && item.vendors[0].taxClass !== ""
        ? item.vendors[0].taxClass
        : item.taxClass;

    let combarry = [];
    if (item?.combination && item?.vendors?.[0]?.combination?.length > 0) {
      item.vendors[0].combination.forEach((vitem) => {
        item.combination.forEach((pitem) => {
          if (
            pitem?.url === vitem?.url &&
            vitem?.purchase_price !== undefined &&
            pitem?.active
          ) {
            combarry.push({
              com: pitem?.value?.join(" x "),
              price: vitem.purchase_price,
              sitePrice: pitem.sPrice || pitem.price,
              status: "Blocked",
              url: vitem.url,
              stock: vitem?.stock,
              prSts: vitem?.prSts,
            });
          }
        });
      });
    }

    return { baseImg, taxClass, combarry };
  };

  const openDetailPopup  = (item) => { setCurrentProductDetail(item); setShowDetailPopup(true); };
  const closeDetailPopup = ()     => { setShowDetailPopup(false); setCurrentProductDetail(null); };

  // ─── Render ────────────────────────────────────────────────────────────────
  return (
    <>
      <div className="inventry-page" id="outer">

        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-3 px-3 pt-3">
          <div className="blocked-products-header" style={{ flex: 1 }}>
            <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
              <i className="bi bi-info-circle me-2"></i>
              The list of products which have been blocked for some reason in last 30 days
            </p>
          </div>
        </div>

        {/* Search */}
        <div className="d-flex inv_filter_cntn">
          <div className="topprodsearch d-flex align-items-center">
            <ProductSKUSearch
              totalRcordId={totalRecordId}
              searchByKeyword={handleSearch}
              apiCall={getBlockedProducts}   // called when search is cleared
              count={totalRecords}
              from="inventory"
              flag="Product"
            />
          </div>
        </div>

        {/* Products table */}
        <div className="container_invent" id="orDeskContain">
          <div className="tab table-responsive">
            <table
              className="ord_table new-table-design"
              style={{ width: "100%", tableLayout: "fixed" }}
            >
              <thead>
                <tr className="table_ord_title_row">
                  <th className="thead_title pb-1" style={{ width: "30%" }}>Product</th>
                  <th className="thead_title" style={{ width: "10%" }}>Stock</th>
                  <th className="thead_title" style={{ width: "20%" }}>Transfer Price</th>
                  <th className="thead_title" style={{ width: "40%" }}>Reason</th>
                </tr>
              </thead>
              <tbody>
                {totalRecords > 0
                  ? blockedProductsList.map((item, index) => {
                      const { baseImg, taxClass, combarry } = buildCardProps(item);
                      const blockedReason = item?.vendors?.[0]?.reason || "Please contact seller support";

                      return (
                        <BlockedProductCard
                          key={item._id}
                          id={index}
                          taxClass={taxClass}
                          SKU={item?.SKU}
                          urlKey={item?.urlKey}
                          lead={item?._id}
                          productName={item?.productName}
                          image={baseImg}
                          vendor={item?.vendors[0]}
                          price={item?.vendors?.[0]?.purchase_price}
                          quantity={item?.vendors[0]?.stock}
                          combination={combarry.length > 0 ? combarry : undefined}
                          blockedReason={blockedReason}
                          onDetailClick={() => openDetailPopup(item)}   // ← add

                        />
                      );
                    })
                  : null
                }
                {loaderProduct === "none" && blockedProductsList.length === 0 && (
                  <tr>
                    <td colSpan={4} style={{ textAlign: "center", padding: "1rem" }}>
                      No blocked products found in the last 30 days.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <PaginationNew
            number={totalRecords}
            paginate={paginate}
            activ={selectedPage}
            comp={compForPagination}
          />
          {showDetailPopup && currentProductDetail && (
            <CategoryProductPopup
              description={currentProductDetail.description}
              sdescription={currentProductDetail.shortDescription}
              descriptionNew={currentProductDetail.descriptionNew || []}
              specificationNew={currentProductDetail.specificationNew || []}
              name={currentProductDetail.productName}
              price={currentProductDetail.lowestPrice}
              SKU={currentProductDetail.SKU}
              onClose={closeDetailPopup}
              images={currentProductDetail.images}
              pkgs={currentProductDetail.pkgs}
              manufacturerName={currentProductDetail.manufacturerName}
            />
          )}

          <div className="d-flex justify-content-center loader-bt" id="enNewLoader">
            <div className="spinner-border" role="status" style={{ display: loaderProduct }}>
              <span className="sr-only"></span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockedProducts;